export const REQUEST_URL_HEADER_NAME = 'x-request-url';
export const REDIRECT_PATH_SEARCH_PARAM_NAME = 'redirectPath';
export const SERVER_ERROR_CODE_SEARCH_PARAM_NAME = 'serverErrorCode';
